import { Car, Visit, VisitTimeProposition, WorkshopRejectedVisit } from '../../models';
import {
  APPEND_WORKSHOP_UNSCHEDULED_VISITS,
  GET_WORKSHOP_UNSCHEDULED_VISITS,
} from '../constants/visitsUnscheduledList';

/* eslint-disable camelcase */
const convertCar = (car, car_ownership, finished, image) => {
  return new Car(
    car.id,
    car.make_name,
    car.model_name,
    car.variant,
    car.version,
    car.vin,
    car.production_year,
    car.fuel,
    car.engine_capacity,
    car.engine_power_kw,
    car.curb_weight,
    car.first_registration_date,
    car_ownership.car_nickname,
    car_ownership.color,
    car_ownership.owner_id,
    car_ownership.registration_number,
    car_ownership.id,
    finished,
    image,
  );
};

export const getWorkshopUnscheduledVisits = (ownerId, response) => {
  const { count, limit, offset, next, previous, results: visits } = response ?? {};

  const convertedVisits = visits?.map((data) => {
    const {
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      time_proposition,
      alternative_time_proposition,
      car,
      rejection,
      initiated_by,
    } = data;

    const convertedCar = convertCar(car, car_ownership);

    const timePropositions = time_proposition
      ? new VisitTimeProposition(
          id,
          time_proposition.first_proposition,
          time_proposition.second_proposition,
        )
      : null;

    const alternativeTimePropositions = alternative_time_proposition
      ? new VisitTimeProposition(
          id,
          alternative_time_proposition?.first_proposition,
          alternative_time_proposition?.second_proposition,
        )
      : null;

    const workshopRejectedVisit =
      rejection?.length > 0
        ? new WorkshopRejectedVisit(
            rejection[0].first_proposition,
            rejection[0].second_proposition,
            rejection[0].rejection_reason,
          )
        : null;

    return new Visit(
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      timePropositions,
      alternativeTimePropositions,
      null,
      convertedCar,
      null,
      workshopRejectedVisit,
      null,
      null,
      null,
      initiated_by,
    );
  });

  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_UNSCHEDULED_VISITS,
      ownerId,
      visits: convertedVisits,
      count,
      limit,
      offset,
      next,
      previous,
    });
  };
};

export const appendWorkshopUnscheduledVisits = (ownerId, response) => {
  const { count, limit, offset, next, previous, results: visits } = response ?? {};
  const convertedVisits = visits.map((data) => {
    const {
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      time_proposition,
      alternative_time_proposition,
      car,
      rejection,
      initiated_by,
    } = data;

    const convertedCar = convertCar(car, car_ownership);

    const timePropositions = time_proposition
      ? new VisitTimeProposition(
          id,
          time_proposition?.first_proposition,
          time_proposition?.second_proposition,
        )
      : null;

    const alternativeTimePropositions = alternative_time_proposition
      ? new VisitTimeProposition(
          id,
          alternative_time_proposition?.first_proposition,
          alternative_time_proposition?.second_proposition,
        )
      : null;

    const workshopRejectedVisit =
      rejection?.length > 0
        ? new WorkshopRejectedVisit(
            rejection[0].first_proposition,
            rejection[0].second_proposition,
            rejection[0].rejection_reason,
          )
        : null;

    return new Visit(
      id,
      car_ownership,
      workshop_ownership,
      scheduled_time,
      message_from_client,
      message_from_workshop,
      status,
      time_preference,
      timePropositions,
      alternativeTimePropositions,
      null,
      convertedCar,
      null,
      workshopRejectedVisit,
      null,
      null,
      null,
      initiated_by,
    );
  });

  return (dispatch) => {
    dispatch({
      type: APPEND_WORKSHOP_UNSCHEDULED_VISITS,
      ownerId,
      visits: convertedVisits,
      count,
      limit,
      offset,
      next,
      previous,
    });
  };
};
